import { ANALYTICS_CONFIG } from '../config/analytics-config.js';
import { getIdToken } from './firebase-auth.js';

const BASE_PATH = '/api/v2/meta/ana/instagram/keywords';

async function keywordRequest(path = '', options = {}, retryAuth = false) {
  const token = await getIdToken(!!retryAuth);
  const url = ANALYTICS_CONFIG.apiBase.replace(/\/$/, '') + BASE_PATH + path;
  const method = options.method || 'GET';
  const response = await fetch(url, {
    method,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token
    },
    body: method === 'GET' ? undefined : JSON.stringify(options.body || {})
  });

  if (response.status === 401 && !retryAuth) return keywordRequest(path, options, true);
  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    const message =
      (payload && (payload.message || (payload.error && payload.error.message) || payload.error)) ||
      'No se pudo actualizar la automatización de Instagram.';
    const error = new Error(String(message));
    error.status = response.status;
    error.payload = payload;
    throw error;
  }
  return payload || {};
}

export async function fetchInstagramKeywordRules() {
  const payload = await keywordRequest();
  return Array.isArray(payload.rules) ? payload.rules : [];
}

export async function saveInstagramKeywordRule(rule) {
  const id = String(rule && rule.id || '').trim();
  const path = id ? '/' + encodeURIComponent(id) : '';
  const method = id ? 'PUT' : 'POST';
  const payload = await keywordRequest(path, { method, body: rule || {} });
  return payload.rule;
}

export async function setInstagramKeywordRuleEnabled(id, enabled) {
  const payload = await keywordRequest('/' + encodeURIComponent(id) + '/enabled', {
    method: 'PATCH',
    body: { enabled: Boolean(enabled) }
  });
  return payload.rule;
}
